import { render } from "./ComponentPlaceholder.vue?vue&type=template&id=4519dc58"
const script = {}

import "./ComponentPlaceholder.vue?vue&type=style&index=0&id=4519dc58&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__